'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { AuthenticationHeader } from './_layout/-components/AuthenticationHeader';
export const Route = createFileRoute('/_staff/settings/authentication/_layout')({
  component: RouteComponent
});
function RouteComponent() {
  return <VStack className="h-full gap-0">
      <AuthenticationHeader />
      <div className="relative min-h-0 flex-1 overflow-auto bg-neutral-gray-light-2">
        <Outlet />
      </div>
    </VStack>;
}